<!-- お知らせ一覧 -->
<template>
  <div class="crly-o-news-list">
    <h2 v-if="!sideMenu">{{ $t("news.contents.title") }}</h2>
    <ul v-if="completedLoad && item_list.length > 0">
      <li
        :class="{ arrow: !sideMenu }"
        v-for="item in item_list"
        :key="item.id"
        @click.stop="showDetail(item.id)"
      >
        <span class="child-icon" v-if="sideMenu"></span>
        <div class="date">
          {{ item.pub_date.replace(/-/g, ".").slice(0, -15) }}
        </div>
        <span :class="{ read: item.read }">{{ item.display_title }}</span>
      </li>
    </ul>
    <ul v-else-if="completedLoad">
      <li>{{ $t("news.contents.nothing") }}</li>
    </ul>
    <div class="newsList" v-if="sideMenu" @click="toNewsList">
      {{ $t("news.contents.title") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CrlyOrganismsNewsList",
  props: {
    /**
     * サイドメニューお知らせ一覧の場合true
     */
    sideMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      item_list: [],
      completedLoad: false,
      readList: this.$store.getters["clickNewsCookie/getNews"]
    };
  },
  mounted() {
    // お知らせ取得
    this.getNews();
  },
    methods: {
    toNewsList() {
      this.$emit("close");
      this.$router.push({ name: "CrlyNews" });
    },
    showDetail(id) {
      // クッキーとローカルストレージにお知らせid保存
      // 現在の既読リストを一旦取得
      let newsList = this.$store.getters["clickNewsCookie/getNews"];
      // 既読リストに追加
      newsList.push(id);
      const set = new Set(newsList);
      const newArr = [...set];
      // クッキーとローカルストレージに上書き(更新日時も更新)
      this.$store.commit("clickNewsCookie/setNews", newArr);
      this.$store.commit("clickNewsLStorage/setNews", newArr);
      let dt = new Date();
      this.$store.commit("clickNewsCookie/setLastUpdateDate", dt.getTime());
      this.$store.commit("clickNewsLStorage/setLastUpdateDate", dt.getTime());
      console.log("■既読更新dateCookie⇒", this.$store.getters["clickNewsCookie/getLastUpdateDate"]);
      console.log("■既読更新dateStorage⇒", this.$store.getters["clickNewsLStorage/getLastUpdateDate"]);
      console.log("■既読更新listCookie⇒", this.$store.getters["clickNewsCookie/getNews"]);
      console.log("■既読更新listStorage⇒", this.$store.getters["clickNewsLStorage/getNews"]);
      //モーダルクローズ
      this.$emit("close");
      // お知らせ詳細画面遷移
      this.$router.push("/newsDetail/" + id);
    },
    getNews() {
      this.$store.dispatch("loadingCrly/show", 10);
      this.item_list = [];
      this.completedLoad = false;
      this.$repositories("cms")
        .getNews()
        .then((res) => {
          this.dataMaker(res);
          this.controlPagination = res.data.links;
        })
        .catch((err) => {
          console.log("cms:お知らせ一覧取得エラー", err);
        })
        .finally(() => {
          this.completedLoad = true;
          this.$store.dispatch("loadingCrly/hide", 10);
        });
    },
    dataMaker(obj) {
      let lists = obj.data.data;
      const newsTypeNames = obj.data.included;
      if (lists != null) {
        if (this.sideMenu) {
          lists = lists.slice(0, 5);
        }
        lists.forEach((item) => {
          const newsTypeName = newsTypeNames.find(
            (el) => el.id === item.relationships.news_type.data.id
          );
          this.item_list.push({
            pub_date: item.attributes.pub_date,
            news_type_name: newsTypeName.attributes.name,
            display_title: item.attributes.display_title,
            id: item.id,
            read: this.readList.includes(item.id)
          });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/organisms/news/list.scss";
</style>
